import api from '@/api/index.js'

const emv_tap = {
  state: {
    loading: false,
    updating: false,
    data: null,
    error: null
  },

  mutations: {
    SET_EMV_TAP_LOADING: (state, v) => {
      state.loading = v
    },
    SET_EMV_TAP_UPDATING: (state, v) => {
      state.updating = v
    },
    SET_EMV_TAP: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_EMV_TAP_ERROR: (state, error) => {
      state.error = error
    },
  },

  actions: {
    LoadEmvTap({commit}, query) {
      commit('SET_EMV_TAP', null)
      commit('SET_EMV_TAP_ERROR', null)
      commit('SET_EMV_TAP_LOADING', true)
      return api.get(`emv-taps/${query.id}`)
        .then((response) => {
          commit('SET_EMV_TAP', response)
        })
        .catch((error) => {
          commit('SET_EMV_TAP_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_EMV_TAP_LOADING', false)
        })
    },
  }
}

export default emv_tap
